import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CrowdFlowSensorSiteStore, CrowdFlowSensorSiteState } from './crowd-flow-sensor-site.store';

@Injectable({ providedIn: 'root' })
export class CrowdFlowSensorSiteQuery extends QueryEntity<CrowdFlowSensorSiteState> {

  constructor(protected store: CrowdFlowSensorSiteStore) {
    super(store);
  }

}
